import {createAction} from '@ngrx/store';

export const openAdvancedSearch = createAction(
    '[Layout] Open AdvancedSearch'
);

export const closeAdvancedSearch = createAction(
    '[Layout] Close AdvancedSearch'
);

export const openQuoteList = createAction(
    '[Layout] Open QuoteList'
);

export const closeQuoteList = createAction(
    '[Layout] Close QuoteList'
);

export const openQuoteViewSelection = createAction(
    '[Layout] Open QuoteViewSelection'
);

export const closeQuoteViewSelection = createAction(
    '[Layout] Close QuoteViewSelection'
);

export const openSubmittedQuoteList = createAction(
    '[Layout] Open SubmittedQuoteList'
);

export const openCreateNewQuoteMenu = createAction(
    '[Layout] Open CreateNewQuoteMenu'
);

export const closeCreateNewQuoteMenu = createAction(
    '[Layout] Close CreateNewQuoteMenu'
);

export const openSiteMenu = createAction(
    '[Layout] Open SiteMenu'
);

export const closeSiteMenu = createAction(
    '[Layout] Close SiteMenu'
);
